import { useContext } from 'react';
import { IToastMessageContext, ToastMessageContext } from './ToastMessageContext';

const useToastMessage = (): IToastMessageContext => useContext(ToastMessageContext);

export default useToastMessage;
